export default __webpack_public_path__ + "static/media/NRLevel5RightSideMap.994f933c.jpg";